import React, { useState, useRef, useEffect } from 'react';
import RTButton from './RTButton';
import { FaChevronDown } from 'react-icons/fa'; // Use a different arrow icon

const RTDropdownButton = ({ label = "Actions", options = [] }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="rt-dropdown" ref={dropdownRef} style={{ position: 'relative', display: 'inline-block' }}>
      <RTButton
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        style={{
          minWidth: 60, // Reduced from 120 to 80
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0,
          position: 'relative'
        }}
      >
        <span style={{ paddingRight: 12 }}>{label}</span>
        <FaChevronDown style={{ fontSize: 14, verticalAlign: 'middle', marginRight: 0 }} />
      </RTButton>
      {open && (
        <div
          className="rt-dropdown-menu"
          style={{
            position: 'absolute',
            top: '110%',
            left: 0,
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: 6,
            boxShadow: '0 2px 8px rgba(21,60,127,0.08)',
            minWidth: 140,
            zIndex: 1000,
            padding: 4
          }}
        >
          {options.map((opt, idx) => (
            <RTButton
              key={idx}
              type="button"
              variant="secondary"
              style={{
                width: '100%',
                textAlign: 'left',
                borderRadius: 4,
                margin: '2px 0',
                background: 'none',
                color: '#153C7F',
                fontWeight: 500,
                padding: '8px 12px'
              }}
              onClick={() => {
                setOpen(false);
                opt.onClick();
              }}
            >
              {opt.label}
            </RTButton>
          ))}
        </div>
      )}
    </div>
  );
};

export default RTDropdownButton;